import { rem } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: 644px ${rem(310)};
	grid-template-rows: ${rem(120)};
	padding: ${rem(24)} 0;
	grid-gap: ${rem(24)};
	@media (max-width: 1080px) {
		grid-template: initial;
		grid-template-areas: 'card' 'fields';
	}
`;

export const Fields = styled.div`
	@media (max-width: 1080px) {
		grid-area: fields;
	}
`;
export const Card = styled.div`
	@media (max-width: 1080px) {
		grid-area: card;
	}
`;

export const SecondaryContainer = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	grid-gap: 8px;
`;

export const ManageUsersCardsContainer = styled.div`
	display: grid;
	grid-gap: ${rem(32)};
`;
